import React from 'react';
import "./managegroups.css"
import { Outlet } from 'react-router-dom';

const ManageGroupsPage = () => {
  return (
    <section className='manage-groups-main' >
        <Outlet />
    </section>
  )
}

export default ManageGroupsPage
